import BannerEvents from "components/common/BannerEvents";
import EventListStatic from "components/common/EventListStatic";

function DashBoardEvents() {
    return (
        <>
            <BannerEvents />
            <EventListStatic />
        </>
    );
}

export default DashBoardEvents;
